import { FC } from 'react';

import { AnimatedDisplayValue } from '../../components/animated-number/index';
import { AppFormattedMessage } from '../../components/app-formatted-message/index';
import { SafeHooks, useSelectedCompany } from '../../hooks/index';
import { toNumber } from '../../utils/to-number.util';
import { SummaryItem } from '../cap-table/summary-item';

type OverallStatusProps = {
  companyId: string;
};

export const OverallStatus: FC<OverallStatusProps> = ({ companyId }) => {
  const { selectedCompany } = useSelectedCompany();
  const currency = selectedCompany?.currency;

  const { overallStatus } = SafeHooks.useSafeOverallStatus({ companyId });

  return (
    <div className="flex min-h-full w-full flex-col items-center rounded-lg bg-gray-50 p-1">
      <div className="flex w-full items-start justify-between gap-4 px-4 py-3">
        <span className="w-full text-left text-[10px] font-bold uppercase leading-4 tracking-[1px] text-gray-700">
          <AppFormattedMessage id="OVERALL_STATUS" />
        </span>
      </div>

      <div className="flex h-full w-full flex-wrap content-start gap-3 rounded-md bg-white p-3 shadow-sm max-lg:flex-col">
        <SummaryItem
          title={<AppFormattedMessage id="INVESTMENT_THROUGH_SAFE" />}
          value={
            <AnimatedDisplayValue
              prefix={currency?.symbol || currency?.iso3?.toLocaleUpperCase()}
              roundTo={0}
              value={toNumber(overallStatus?.totalConvertedInvestment)}
            />
          }
        />
        <SummaryItem
          title={<AppFormattedMessage id="SHARES_CONVERTED_FROM_SAFE" />}
          value={
            <AnimatedDisplayValue
              roundTo={0}
              value={toNumber(overallStatus?.totalConvertedShares)}
            />
          }
        />

        <SummaryItem
          title={<AppFormattedMessage id="SAFE_HOLDERS" />}
          value={<AnimatedDisplayValue roundTo={0} value={overallStatus?.safeHolders} />}
        />
        <SummaryItem
          title={<AppFormattedMessage id="CONVERTED_SAFE_HOLDERS" />}
          value={<AnimatedDisplayValue roundTo={0} value={overallStatus?.convertedSafeHolders} />}
        />

        <SummaryItem
          title={<AppFormattedMessage id="INVESTMENT_PENDING_CONVERSION" />}
          value={
            <AnimatedDisplayValue
              prefix={currency?.symbol || currency?.iso3?.toLocaleUpperCase()}
              roundTo={0}
              value={toNumber(overallStatus?.totalPendingInvestment)}
            />
          }
        />
      </div>
    </div>
  );
};
